import React from 'react';

import * as Styled from './styled/HeroSubtitle';

enum HeroSubtitleStyles {
  H2 = 'h2',
  H3 = 'h3',
  H5 = 'h5'
}

type HeroSubtitleProps = {
  subTitle: string;
  styleOf: HeroSubtitleStyles;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'span' | 'p' | 'label';
};

const HeroSubtitle: React.FunctionComponent<HeroSubtitleProps> = ({
  subTitle,
  styleOf = HeroSubtitleStyles.H2,
  ...props
}) => {
  switch (styleOf) {
    case HeroSubtitleStyles.H3:
      return <Styled.SubTitleH3Styled {...props}>{subTitle}</Styled.SubTitleH3Styled>;
    case HeroSubtitleStyles.H5:
      return <Styled.SubTitleH5Styled {...props}>{subTitle}</Styled.SubTitleH5Styled>;
    case HeroSubtitleStyles.H2:
    default:
      return <Styled.SubTitleH2Styled {...props} $removeBackground>{subTitle}</Styled.SubTitleH2Styled>;
  }
};

export default HeroSubtitle;
export { HeroSubtitleStyles };
